import React from "react";
import { Button } from "./Button";
import ProgressBar from "./ProgressBarComponent";

interface Props {
  text: string;
  buttontext?: string;
  buttonevent?: () => void;
  progressvalue?: string;
  isSubmitting?: boolean;
  rightElement?: React.ReactNode; // 👈 new prop
}

export const PageHeader: React.FC<Props> = ({
  text,
  buttontext,
  buttonevent,
  progressvalue,
  isSubmitting,
  rightElement,
}) => {
  return (
    <div className="flex items-center justify-between my-4">
      <h2 className="font-sans text-lg font-semibold text-left capitalize md:text-2xl font-outfit">
        {text}
      </h2>

      {rightElement ??
        (buttontext && (
          <Button
            onClick={buttonevent}
            isSubmitting={isSubmitting}
            disabled={isSubmitting}
          >
            {buttontext}
          </Button>
        ))}

      {progressvalue && <ProgressBar progressvalue={progressvalue} />}
    </div>
  );
};
